/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Dienstamanderenort4Inputs */



/**

* @param {_Class_Dienstamanderenort4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_dienstamanderenort4 = /** @type {((inputs?: _Class_Dienstamanderenort4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Dienstamanderenort4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Dienst am anderen Ort")
});
export { _class_dienstamanderenort4 as "_class_DienstAmAnderenOrt" }